import React from 'react';
import { useI18n } from './i18n';
import PdfButton from './PdfButton';
import ShareLinkButton from './ShareLinkButton';
import AttachmentList from './AttachmentList';
import { FoodSheetExtras } from './foodSheetBlocks';

// One food sheet in a list (dish detail of the catalogue, and the food-sheet archive).
// Props: sheet, heading (the first line: label, dish, ...), meId (current user id), onEdit(sheet), onDelete(sheet).
function FoodSheetItem({ sheet, heading, meId, onEdit, onDelete }) {
  const { t, formatDate } = useI18n();
  const isOwner = !!meId && sheet.owner_id === meId;
  return (
    <li className="sheet-summary" style={{ flexWrap: 'wrap' }}>
      <span>
        {heading}
        {sheet.owner_id ? ` · ${t('catalog.registered')}` : ` · ${t('catalog.anonymous')}`}
        {(sheet.tasting_date || sheet.created_at) ? ` · ${formatDate(sheet.tasting_date || sheet.created_at)}` : ''}
        {sheet.chef ? ` · ${t('catalog.food.chef')}: ${sheet.chef}` : ''}{sheet.venue ? ` · ${sheet.venue}` : ''}
      </span>
      <span className="food-actions">
        <PdfButton path={`food-sheets/${sheet.id}/pdf`} className="chip" fallbackName="food-sheet.pdf" />
      </span>
      <ShareLinkButton type="food" id={sheet.id} visibility={sheet.visibility} isOwner={isOwner} />
      {isOwner && (
        <span className="food-actions">
          <button type="button" className="chip" onClick={() => onEdit(sheet)}>{t('ui.edit')}</button>
          <button type="button" className="chip" onClick={() => onDelete(sheet)}>{t('ui.delete')}</button>
        </span>
      )}
      <div style={{ flexBasis: '100%' }}>
        <FoodSheetExtras sheet={sheet} />
        <AttachmentList sheetId={sheet.id} canEdit={isOwner} />
      </div>
    </li>
  );
}

export default FoodSheetItem;
